<template>
  <div id="contact">

    <!-- <canvas></canvas> -->
    <main id="main" data-page-id="home">
      
      <section class="section-abuse active" style="visibility: visible;">
        <div class="abuse-header__block">
          <div class="container row">
            <div class="text-block center-text">
              <h1 class="md-title title"> Consumer Electronics Pricing Analytics - Trends - Insights - Forecasting </h1>
            
            </div>

          </div>
        </div>
        <div class="abuse-form__block form__block">
          <div class="container">
          <form action="#" id="abuse-form" novalidate="novalidate" class="custom-form abuse-form" v-if="!this.submitStatus">
            <div class="form__wrap">
                <div class="form-content__wrap formmobile" style="justify-content: center;">
               
                  <div class="col-md-6" >
                 
                    <div class="row">
                      <div class="input__wrap">
                        <input type="text" v-model.trim="$v.name.$model" id="abuse.fullName" name="abuse.fullName"
                          required="required" class="required "
                          :class="{ 'error': $v.name.$error,'valid':!$v.name.$invalid }"> <label for="abuse.fullName"
                          class="input-label">Full
                          Name</label>
                        <div class="error-tooltip__wrap">
                          <h4 class="menu-link up-text error-tooltip__content">Invalid Full Name</h4>
                          <p class="description">You can use only English letters, space, comma, apostrophe, dash, and
                            period (,.'-)</p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="input__wrap">
                        <input type="email" v-model.trim="$v.email.$model" id="abuse.email" name="abuse.email"
                          required="required" class="required"
                          :class="{ 'error': $v.email.$error,'valid':!$v.email.$invalid }">
                        <label for="abuse.email" class="input-label">Email Address
                          </label>
                        <div class="error-tooltip__wrap">
                          <h4 class="menu-link up-text error-tooltip__content">Invalid email</h4>
                          <p class="description">Please, check that you include an '@' and '.' in the email address</p>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="input__wrap password__wrap" style="margin-bottom: 20px;">
                        <input v-model.trim="phone" type="tel" id="abuse.phoneNumber" name="abuse.phoneNumber"
                          required="required" class="required"
                          :class="{ 'valid':phone.length }"> <label
                          for="abuse.phoneNumber" class="input-label">Phone Number</label>
                        <div class="error-tooltip__wrap">
                          <h4 class="menu-link up-text error-tooltip__content">Invalid Phone Number</h4>
                          <p class="description">You can use only numbers &amp; + (plus) symbol</p>
                        </div>
                      
                      </div>
                      <div style="padding:20px 0;width:100%">

                        When you click 'download' you agree to our 
                        <a href="/#/term"  style="color: #24ad60;">
                          terms and conditions
                        </a>
                        and
                       <a href="/#/privacy" style="color: #24ad60;">
                          privacy policy
                       </a>

                      </div>
                      <div>
                        <vue-recaptcha
                        ref="recaptcha"
                        @verify="onCaptchaVerified"
                        @expired="onCaptchaExpired"
                        @render="onCaptchaRendered"
                        size="checkbox"
                        theme	="dark"
                        :sitekey="this.sitekey">
                        </vue-recaptcha>
                      </div>
                    

                    </div>
                       <div class="button__wrap submit__wrap">
                      <button id="abuse-submit" type="button" @click="submit()"
                        class="button button--white-hover-grad button--submit pulse">Download</button>
                  </div>
                  </div>
                  
                </div>
                <div>
      
                </div>
             
              </div>
            </form>
            <div v-else>

              <div class="sentsuccesfully_m">
                  Downloaded Successfully !  <br>

                  <div>
                    <b> File name :</b> <span> {{ getFileName() }} </span>
                  </div>
                  <div>
                    <b> File size :</b> <span> 37.1 MB</span>
                  </div>
                  
                  
              </div>
            </div>
           
          </div>
        </div>
      </section>





      <section class="started-section">
        <video class="bg_innerpages" autoplay muted loop src="../../../assets/video/services.mp4"></video>

        <div class="container row started__container">
          <div class="content__left">
            <div class="js-content-block text-block">
              <h2 class="title md-title">MI</h2>
              <p class="subtitle">this is where imagination meets innovation.</p>
            </div>
          </div>
          <div class="content__right">
            <div class="buttons__wrap">
              <a href="https://web.mobilityintel.com" class="button button--transparent pulse">get started</a>
            </div>
          </div>
        </div>
      </section>

  
    </main>
  </div>
</template>

<script>
  import flexbox from 'flexboxgrid';
  import global from '@/mixins/global';
  import vSelect from 'vue-select';
  import VueRecaptcha from 'vue-recaptcha';


  // import Vuelidate from 'vuelidate';
  import axios from 'axios';
  import {
    required,
    minLength,
    email,
    numeric,
  } from 'vuelidate/lib/validators';

  export default {
    name: 'Download',
    data() {
      return {
        name: '',
        email: '',
        phone: '',
        message: '',
        subject:"",
        sitekey: "6LeKEokaAAAAANt--Lbr__JFA9Dcmm0ncQ0lEMLc",
        widgetId: '',
        submitStatus:false,
        selectedEmail:[],
        recaptchaStatus:false,
        placeholderItem: '2' ,
      
      };
    },
    validations: {
      name: {
        required,
        minLength: minLength(4)
      },
      email: {
        required,
        email
      }
    },

    // components: { Vuelidate },
    mixins: [global],
    beforeMount() {

    },
    computed: {
  getSelectorPlaceholder: function () {
    return this.placeholderItem
  }
  },
    methods: {
     
      submit() {

        var $this = this;
      this.$v.$touch()
      if (this.$v.$invalid || !this.recaptchaStatus ) {
        this.submitStatus = false;
      } else {
        console.log('form is valid')  ;
        
        var form = {
          name:this.name,
          email:this.email,
          phone:this.phone,
          filename:this.$route.params.filename,
        }
        console.log(form);
        this.submitStatus = true ; 
          axios.post('https://mobilityconnect.tech/api/contactform-mobility',form).then(function (response) {
            console.log(response);
            $this.directDownload();
            //download "/static/download/file1.pdf"
          })
          .catch(function (error) {
            console.log(error);
          });
        setTimeout(() => {
          this.submitStatus = 'OK'
        }, 500)
      }},
      directDownload(){
        console.log('direct download');
      
        //full link with host
        var url = window.location.origin + this.getDownloadLink(); 

        console.log(url);
        fetch(url)
        .then(response => response.blob())
        .then(blob => {
          const url = URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;

          var filename = this.$route.params.filename;

          link.download = filename + ".pdf";
          console.log(link.download);

          document.body.appendChild(link);
          console.log('downloaded');
          link.click();
  
          // document.body.removeChild(link);
        })
        .catch(console.error);
      },
      getDownloadLink() {
        //get filename param
        var filename = this.$route.params.filename;
        //get file url
        var url = '/static/download/' + filename + '.pdf';
        return url;
      },
      getFileName() {
        //get filename param
        var filename = this.$route.params.filename;
        return filename + '.pdf';
      },

      NextSlide() {
        var val = $("section.s2").offset().top;
        window.scrollTo({
          top: val,
          behavior: 'smooth'
        });
      },
      setToken: function(token) {
                this.form['g-recaptcha-response'] = token;
      },
      onCaptchaVerified: function(token) {
          this.recaptchaStatus = true;
      },
      onCaptchaExpired: function() {
          this.setToken('');
      },
      onCaptchaRendered: function(id) {
          this.widgetId = id;
      },
    },

    created() {},
    components:{vSelect,VueRecaptcha
    },

    mounted() {
    },
     metaInfo: {
      title: 'Contact',
      // titleTemplate: '%s | vue-meta Example App'
    },
  };

</script>
<style lang="scss">
  @import './style.scss';
@import "vue-select/src/scss/vue-select.scss";

@media screen and (max-width: 768px) {
  .formmobile{
    padding: 0 20px;
}
}
  


.vs__dropdown-toggle {
    border: 1px solid rgb(36,173,96);
    background-color: #1b162f;
    padding: 16px 0;
}
input.vs__search {
    color: #24ad60;
    padding-left: 15px;
    font-weight: 500;
    font-family: 'Roboto';
}

span.vs__selected {
    color: white;
    padding-left: 15px;
    font-weight: 500;
    font-family: 'Roboto';
}

div#vs1__combobox input {
    // color: white;.
     padding-left: 15px;
    font-weight: 500;
    font-family: 'Roboto';
}
button.vs__clear svg path {
    fill: #24ad60;
}

button.vs__clear +svg path {fill: #24ad60;}

div#vs1__combobox {
    padding-right: 17px;
}
iframe.contact_form {
    width: 100%;
    height: 712px;
    overflow: hidden;
    border: 0;
}
@media screen and (max-width:1024px) {
  button#abuse-submit {
    margin-top: 49px;
}
}

@media screen and (max-width:850px) {
iframe.contact_form {
    height: 1212px;
}
.abuse-form__block.form__block .container {
    margin: 0;
    max-width: 100%;
    width: 100%;
    padding: 0;
}
}

</style>



// WEBPACK FOOTER //
// src/components/Download/index.vue